import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import "flatpickr/dist/themes/material_blue.css";
import { isEmpty, map } from "lodash";
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import {
  addLeadType,
  getLeadType,
  updateLeadType,
  deleteLeadType,
} from "../../store/actions";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

const LeadType = props => {
  document.title = "General Settings | Lead Type";

  const dispatch = useDispatch();
 

  const { leadtypes, loading } = useSelector(state => ({
    leadtypes: state.ObjectReducer.leadtypes,
    loading: state.ObjectReducer.loading,
  }));

  const [leadtype, setLeadType] = useState({});
  const [isRight, setIsRight] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  /* -------------------- API Calls -------------------- */

  useEffect(() => {
    dispatch(getLeadType(localStorage.getItem("userId")));
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(leadtypes)) {
      setIsEdit(false);
    }
  }, [leadtypes]);

  /* -------------------- Handlers -------------------- */

  const toggle = () => setIsRight(!isRight);

  const toggleRightCanvas = selected => {
    if (selected) {
      setLeadType({
        id: selected.id,
        leadTypeId: selected.leadTypeId,
        leadTypeTitle: selected.leadTypeTitle,
        agentId: selected.agentId,
      });
      setIsEdit(true);
    } else {
      setLeadType({});
      setIsEdit(false);
    }
    toggle();
  };

  const handleLeadTypeSubmit = values => {
    dispatch(addLeadType(values, history));
  };

  const onClickDelete = selected => {
    setLeadType(selected);
    setDeleteModal(true);
  };

  const handleDeleteLeadType = () => {
    if (leadtype?.id) {
      dispatch(deleteLeadType(leadtype));
      setDeleteModal(false);
    }
  };

  /* -------------------- Render -------------------- */

  return (
    <>
      {loading && <div className="loading">Loading…</div>}
      <ToastContainer autoClose={2000} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteLeadType}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
       
        <Container fluid>
          <Row className="mb20">
            <Col xl="12">
              <Breadcrumbs
                title={props.t("General Settings")}
                breadcrumbItem={props.t("Lead Type")}
              />
            </Col>
          </Row>

          <Row>
           

            <Col xl="12">
              {/* ---------------- Add Form ---------------- */}
              <Formik
                enableReinitialize
                initialValues={{ leadTypeTitle: "" }}
                validationSchema={Yup.object({
                  leadTypeTitle: Yup.string().required("This is required"),
                })}
                onSubmit={handleLeadTypeSubmit}
              >
                {({ errors, touched, handleChange }) => (
                  <Form className="needs-validation">
                    <Card>
                      <CardBody>
                       
                        <Row>
                          <Col sm="3">
                            <FormGroup className="mb-3">
                              <Label>Title *</Label>
                              <SafeField
                                name="leadTypeTitle"
                                onChange={handleChange}
                                type="text"
                                className={
                                  "form-control" +
                                  (errors.leadTypeTitle &&
                                  touched.leadTypeTitle
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="leadTypeTitle"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col sm="2">
                            <button
                              type="submit"
                              className="btn btn-primary w-md"
                              style={{ marginTop: 31 }}
                            >
                              Add
                            </button>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>

                    {/* ---------------- History Table ---------------- */}
                    <Card>
                      <CardBody>
                        <h5 className="card-title">History</h5>
                        <div className="table-responsive">
                          <table className="table table-bordered align-middle table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Title</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {map(leadtypes, (item, index) => (
                                <tr key={index}>
                                  <th>{index + 1}</th>
                                  <td>{item.leadTypeTitle}</td>
                                  <td>
                                   
                                      <>
                                        <ActionEdit
                                          onClick={() =>
                                            toggleRightCanvas(item)
                                          }
                                        />
                                        <ActionDelete
                                          onClick={() => onClickDelete(item)}
                                        />
                                      </>
                                   
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </CardBody>
                    </Card>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>

          {/* ---------------- Update Offcanvas ---------------- */}
          <Offcanvas isOpen={isRight} direction="end" toggle={toggle}>
            <OffcanvasHeader toggle={toggle}>Update</OffcanvasHeader>
            <OffcanvasBody>
              <Formik
                enableReinitialize
                initialValues={{
                  id: leadtype?.id,
                  leadTypeId: leadtype?.leadTypeId,
                  leadTypeTitle: leadtype?.leadTypeTitle || "",
                  agentId: leadtype?.agentId,
                }}
                validationSchema={Yup.object({
                  leadTypeTitle: Yup.string().required("This is required"),
                })}
                onSubmit={values => {
                  if (isEdit) {
                    dispatch(updateLeadType(values));
                  }
                  toggle();
                }}
              >
                {({ errors, touched, handleChange }) => (
                  <Form className="needs-validation">
                    <Row>
                      <Col sm="12">
                        <FormGroup className="mb-3">
                          <Label>Title *</Label>
                          <SafeField
                            name="leadTypeTitle"
                            onChange={handleChange}
                            type="text"
                            className={
                              "form-control" +
                              (errors.leadTypeTitle &&
                              touched.leadTypeTitle
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="leadTypeTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>

                      <Col sm="12">
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                        >
                          Update
                        </button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </OffcanvasBody>
          </Offcanvas>
        </Container>
      </div>
    </>
  );
};

LeadType.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(LeadType);
